import './Initial.css';
import React from 'react';

const Initial = ({ firstName, lastName }) => {
  const name = `${firstName} ${lastName}`;
  const getInitials = (name) => {
    const nameArray = name.split(' ');
    if (nameArray.length === 1) {
      return nameArray[0][0].toUpperCase();
    }
    const initials = nameArray[0][0].toUpperCase() + nameArray[nameArray.length - 1][0].toUpperCase();
    return initials;
  };

  return (
    <div className='initial-container'>
      <div className='initial-circle'>
        {getInitials(name)}
      </div>
    </div>
  );
};

export default Initial;
